document.addEventListener("DOMContentLoaded", function () {
  
  // LAZY VÍDEOS HOME
  const lazyVideos = document.querySelectorAll('.lazy-video');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const videoId = el.dataset.videoId;

        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0&controls=0&playsinline=1&rel=0&modestbranding=1&showinfo=0&loop=1&playlist=${videoId}`;
        iframe.allow = "autoplay; encrypted-media";
        iframe.allowFullscreen = true;
        iframe.setAttribute('frameborder', '0');

        // Substitui o conteúdo
        el.innerHTML = '';
        el.appendChild(iframe);

        observer.unobserve(el);
      }
    });
  }, {
    threshold: 0.25
  });

  lazyVideos.forEach(video => {
    observer.observe(video);

    const button = video.querySelector('.play-button');
    if (button) {
      button.addEventListener('click', () => {
        const videoId = video.dataset.videoId;

        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=0&playsinline=1&rel=0&modestbranding=1&showinfo=0&loop=1&playlist=${videoId}`;
        iframe.allow = "autoplay; encrypted-media";
        iframe.allowFullscreen = true;
        iframe.setAttribute('frameborder', '0');

        video.innerHTML = '';
        video.appendChild(iframe);
      });
    }
  });
});


(function waitForJQuery(){
  if (typeof window.jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
    initCarousel();
  } else {
    setTimeout(waitForJQuery, 50);
  }
})();

function initCarousel() {
  jQuery(function($){
    $('.carousel-reviews').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      autoplay: false,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 992,
          settings: { slidesToShow: 2, slidesToScroll: 2 }
        },
        {
          breakpoint: 576,
          settings: { slidesToShow: 1, slidesToScroll: 1 }
        }
      ]
    });

    $('.carousel-reviews').on('setPosition', function () {
      if (window.AOS) AOS.refresh();
    });
  });
}
